// Helper für DataTables-Übersetzungen (DE/EN/NL/FR/PL)
function getDataTableLanguageConfig() {
  const localeFromShopify =
    (window.Shopify && window.Shopify.locale) || document.documentElement.lang || "de";
  const locale = localeFromShopify.toLowerCase();

  if (locale.startsWith("de")) {
    return {
      url: "https://cdn.datatables.net/plug-ins/1.13.5/i18n/de-DE.json",
      search: "Suche:",
      searchPlaceholder: "Suchen...",
    };
  }
  if (locale.startsWith("en")) {
    return {
      url: "https://cdn.datatables.net/plug-ins/2.3.6/i18n/en-GB.json",
      search: "Search:",
      searchPlaceholder: "Search...",
    };
  }
  if (locale.startsWith("nl")) {
    return {
      url: "https://cdn.datatables.net/plug-ins/2.3.6/i18n/nl-NL.json",
      search: "Zoeken:",
      searchPlaceholder: "Zoeken...",
    };
  }
  if (locale.startsWith("fr")) {
    return {
      url: "https://cdn.datatables.net/plug-ins/2.3.6/i18n/fr-FR.json",
      search: "Recherche :",
      searchPlaceholder: "Rechercher...",
    };
  }
  if (locale.startsWith("pl")) {
    return {
      url: "https://cdn.datatables.net/plug-ins/2.3.6/i18n/pl.json",
      search: "Szukaj:",
      searchPlaceholder: "Szukaj...",
    };
  }

  // Fallback: Englisch
  return {
    url: "https://cdn.datatables.net/plug-ins/2.3.6/i18n/en-GB.json",
    search: "Search:",
    searchPlaceholder: "Search...",
  };
}

//Tabelle mit einer Option (Spaltenanzahl aus DOM, damit optionale Spalte „Beschreibung“ funktioniert)
new DataTable("#1_variantenuebersicht", {
  scrollY:        500,
  deferRender:    true,
  scroller:       true,
  info: false, // Deaktiviert den Info-Text
  columnControl: ['order', ['searchList']],
  ordering: {
    indicators: false,
    handler: false
    },
  responsive: true,
  paging: false,
  columnDefs: [{
    targets: "thousands", // Selektiere alle Spalten mit der Klasse "thousands"
      render: function (data, type, row) {
        if (
          type === "display" &&
          typeof data === "string" &&
          data.match(/^\d+$/)
        ) {
          return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Tausenderpunkt einfügen
        }
        return data; // Originalwert für Sortier- oder Suchzwecke
      }
  },
  {
     targets: "no-controlls",
     columnControl: []
  }],
  language: getDataTableLanguageConfig(),
  info: false, // Deaktiviert den Info-Text
});
//Tabelle mit zwei Optionen (Spaltenanzahl aus DOM)
new DataTable("#2_variantenuebersicht", {
  scrollY:        500,
  deferRender:    true,
  scroller:       true,
  info: false,
  columnControl: ['order', ['searchList']],
  ordering: {
    indicators: false,
    handler: false
    },
  responsive: true,
  paging: false,
  columnDefs: [{
    targets: "thousands", // Selektiere alle Spalten mit der Klasse "thousands"
      render: function (data, type, row) {
        if (
          type === "display" &&
          typeof data === "string" &&
          data.match(/^\d+$/)
        ) {
          return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Tausenderpunkt einfügen
        }
        return data; // Originalwert für Sortier- oder Suchzwecke
      }
  },
  {
     targets: "no-controlls",
     columnControl: []
  }],
  language: getDataTableLanguageConfig(),
  info: false, // Deaktiviert den Info-Text
});
//Tabelle mit drei Optionen (Spaltenanzahl aus DOM)
new DataTable("#3_variantenuebersicht", {
  scrollY:        500,
  deferRender:    true,
  scroller:       true,
  info: false,
  columnControl: ['order', ['searchList']],
  ordering: {
    indicators: false,
    handler: false
    },
  responsive: true,
  paging: false,
  columnDefs: [{
    targets: "thousands", // Selektiere alle Spalten mit der Klasse "thousands"
      render: function (data, type, row) {
        if (
          type === "display" &&
          typeof data === "string" &&
          data.match(/^\d+$/)
        ) {
          return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Tausenderpunkt einfügen
        }
        return data; // Originalwert für Sortier- oder Suchzwecke
      }
  },
  {
     targets: "no-controlls",
     columnControl: []
  }],
  language: getDataTableLanguageConfig(),
  info: false, // Deaktiviert den Info-Text
});
//Tabelle mit 4 Optionen (Spaltenanzahl aus DOM)
new DataTable("#4_variantenuebersicht", {
  scrollY:        500,
  deferRender:    true,
  scroller:       true,
  info: false,
  columnControl: ['order', ['searchList']],
  ordering: {
    indicators: false,
    handler: false
    },
  responsive: true,
  paging: false,
  columnDefs: [{
    targets: "thousands", // Selektiere alle Spalten mit der Klasse "thousands"
      render: function (data, type, row) {
        if (
          type === "display" &&
          typeof data === "string" &&
          data.match(/^\d+$/)
        ) {
          return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Tausenderpunkt einfügen
        }
        return data; // Originalwert für Sortier- oder Suchzwecke
      }
  },
  {
     targets: "no-controlls",
     columnControl: []
  }],
  language: getDataTableLanguageConfig()
});
//Tabelle mit 5 Optionen (Spaltenanzahl aus DOM)
new DataTable("#5_variantenuebersicht", {
  scrollY:        500,
  deferRender:    true,
  scroller:       true,
  info: false,
  columnControl: ['order', ['searchList']],
  ordering: {
    indicators: false,
    handler: false
    },
  responsive: true,
  paging: false,
  columnDefs: [{
    targets: "thousands", // Selektiere alle Spalten mit der Klasse "thousands"
      render: function (data, type, row) {
        if (
          type === "display" &&
          typeof data === "string" &&
          data.match(/^\d+$/)
        ) {
          return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Tausenderpunkt einfügen
        }
        return data; // Originalwert für Sortier- oder Suchzwecke
      }
  },
  {
     targets: "no-controlls",
     columnControl: []
  }],
  language: getDataTableLanguageConfig(),
  info: false, // Deaktiviert den Info-Text
});
//Tabelle mit 6 Optionen (Spaltenanzahl aus DOM)
new DataTable("#6_variantenuebersicht", {
  scrollY:        500,
  deferRender:    true,
  scroller:       true,
  info: false,
  columnControl: ['order', ['searchList']],
  ordering: {
    indicators: false,
    handler: false
    },
  responsive: true,
  paging: false,
  columnDefs: [{
    targets: "thousands", // Selektiere alle Spalten mit der Klasse "thousands"
      render: function (data, type, row) {
        if (
          type === "display" &&
          typeof data === "string" &&
          data.match(/^\d+$/)
        ) {
          return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Tausenderpunkt einfügen
        }
        return data; // Originalwert für Sortier- oder Suchzwecke
      }
  },
  {
     targets: "no-controlls",
     columnControl: []
  }],
  language: getDataTableLanguageConfig(),
  info: false, // Deaktiviert den Info-Text
});

let cart = []; // Array, um den Warenkorb zu speichern
function addToCart(variantId, quantity) {
  console.log(`Variante ${variantId} mit Menge ${quantity} hinzugefügt.`);
  // Überprüfen, ob die Variante bereits im Warenkorb ist
  const existingItem = cart.find((item) => item.id === variantId);

  if (existingItem) {
    // Menge aktualisieren, wenn das Produkt bereits existiert
    existingItem.quantity += parseInt(quantity);
  } else {
    // Neues Produkt hinzufügen
    cart.push({ id: variantId, quantity: parseInt(quantity) });
  }

  console.log(`Warenkorb:`, cart); // Nur für Debugging-Zwecke
  updateCartDisplay();
}
function updateCartDisplay() {
  const cartContainer = document.getElementById("cart-display");
  cartContainer.innerHTML = ""; // Warenkorb-UI leeren

  cart.forEach((item) => {
    const cartItem = document.createElement("div");
    cartItem.textContent = `Produkt-ID: ${item.id}, Menge: ${item.quantity}`;
    cartContainer.appendChild(cartItem);
  });
}

function clearCart() {
  cart = []; // Warenkorb leeren
  updateCartDisplay();
  console.log("Warenkorb geleert");
}
document.addEventListener("click", function (event) {
  const button = event.target.closest(".add-to-cart-btn");

  if (button) {
    event.preventDefault();

    const variantId = button.getAttribute("data-variant-id");
    const quantityField = button.closest("td").querySelector(".quantity-field");
    const quantity = quantityField ? parseInt(quantityField.value) || 1 : 1;

    console.log("Klick erkannt");
    console.log("variantId:", variantId);
    console.log("quantity:", quantity);

    if (variantId) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: parseInt(variantId.replace(/\./g, "")),
          quantity: quantity,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Fehler beim Hinzufügen zum Warenkorb");
          }
          return response.json();
        })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error("Fehler:", error);
          alert("Ein Fehler ist aufgetreten. Bitte versuche es erneut.");
        });
    } else {
      alert("Variant-ID fehlt!");
    }
  }
});

document.addEventListener("click", function (event) {
  const button = event.target.closest(".add-to-cart-sample-btn");
  //const btn = document.getElementById('sample-add-button');
  const msg = document.getElementById("sample-message");
  if (!button) return;
  const quantityField = button.closest("td").querySelector(".quantity-field");
  const quantity = quantityField ? parseInt(quantityField.value) || 1 : 1;
  const variantId = button.getAttribute("data-variant-id");
  if (!variantId) return;
  console.log(variantId);
  // Prüfen, ob schon im Warenkorb
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const alreadyInCart = cart.items.find(
        (item) => item.variant_id === parseInt(variantId)
      );
      console.log(alreadyInCart);
      if (alreadyInCart) {
        msg.textContent = "Dieses Muster ist bereits im Warenkorb.";
        return;
      }

      // Produkt hinzufügen
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: parseInt(variantId.replace(/\./g, "")),
          quantity: quantity,
        }),
      })
        .then(() => {
          // Direkt zum Checkout mit Rabattcode
          window.location.href = "/checkout?discount=muster";
        })
        .catch((err) => {
          console.error("Fehler beim Hinzufügen:", err);
          msg.textContent = "Fehler beim Hinzufügen des Musters.";
        });
    });
});
